var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpgradePlanWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 18,
    viewBox: "0 0 23 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.69573 0.5H14.3043C15.6363 0.5 16.8772 1.1762 17.5992 2.2955L20.3062 6.49172C21.102 7.72537 21.142 9.30022 20.4099 10.5727L17.5552 15.5344C16.8555 16.7504 15.5595 17.5 14.1565 17.5H8.8435C7.44054 17.5 6.14449 16.7504 5.44483 15.5344L2.59011 10.5727C1.85798 9.30023 1.89801 7.72537 2.69383 6.49172L5.40078 2.2955C6.12284 1.1762 7.36374 0.5 8.69573 0.5Z",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.46551 6.34226L7.18562 7.61861C6.81422 7.98898 7.03 8.62447 7.55013 8.69213L11.1878 9.16529C11.5024 9.20622 11.7379 9.47427 11.7379 9.79159V12.9256C11.7379 13.4878 12.4173 13.7698 12.8154 13.3728L14.4023 11.7904C14.5211 11.6719 14.5879 11.511 14.5879 11.3431V10.4183C14.5879 10.2673 14.642 10.1212 14.7405 10.0067L15.8603 8.70387C15.9587 8.58931 16.0129 8.44325 16.0129 8.29219V5.13158C16.0129 4.78277 15.7301 4.5 15.3813 4.5H12.474C12.3068 4.5 12.1464 4.5663 12.028 4.68437L10.7353 5.97353C10.6169 6.09159 10.4565 6.15789 10.2893 6.15789H8.91149C8.74428 6.15789 8.58391 6.2242 8.46551 6.34226Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.631579
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.59785 11.4019L7.37618 12.5072C7.29778 12.8981 7.59674 13.263 7.99543 13.263H9.08212C9.38306 13.263 9.64219 13.0506 9.70137 12.7556L9.92303 11.6503C10.0014 11.2594 9.70248 10.8945 9.30379 10.8945H8.2171C7.91616 10.8945 7.65703 11.1069 7.59785 11.4019Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.631579
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpgradePlanWhite);
export default __webpack_public_path__ + "static/media/upgrade-plan-white.93d159b71ff2806c3fcb8894233d16c5.svg";
export { ForwardRef as ReactComponent };